import { RefObject } from 'react';
import type { NoteFieldRef } from './NoteField';

/**
 * Flushes debounced note autosave before a full parent save so the latest editor
 * value is persisted and in-flight parent note PATCHes cannot race the save.
 *
 * @param noteFieldRef - Ref to the dialog's `NoteField`.
 * @returns True when flush completed without error; false when autosave failed.
 */
export async function flushPendingNoteAutosave(
  noteFieldRef: RefObject<NoteFieldRef | null>
): Promise<boolean> {
  const result = (await noteFieldRef.current?.flushAndWait()) ?? 'noop';
  return result !== 'error';
}

/**
 * Awaits a note autosave flush without blocking the caller when it fails.
 * Use when the impending parent save already includes the latest note text.
 *
 * @param noteFieldRef - Ref to the dialog's `NoteField`.
 */
export async function awaitFlushPendingNoteAutosave(
  noteFieldRef: RefObject<NoteFieldRef | null>
): Promise<void> {
  await flushPendingNoteAutosave(noteFieldRef);
}
